import { createContext, useContext } from 'react';

export type RenderedFlyoverPlaybackState = 'playing' | 'paused' | 'finished';

export interface RenderedFlyoverContextType {
  playbackState: RenderedFlyoverPlaybackState;
  playbackSpeedMultiplier: number;
  setPlaybackSpeedMultiplier: (multiplier: number) => void;
  progress: number;
  setProgress: (progress: number) => void;
  pause: () => void;
  resume: () => void;
  restart: () => void;
  userAgent?: string;
}

export const RenderedFlyoverContext = createContext<
  RenderedFlyoverContextType | undefined
>(undefined);

export const useRenderedFlyoverState = (): RenderedFlyoverContextType => {
  const context = useContext(RenderedFlyoverContext);

  if (!context) {
    throw new Error(
      'useRenderedFlyoverState must be used within the RenderedFlyover component'
    );
  }
  return context;
};
